import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { Button, Container, Form, Message, Modal, Loader, Dimmer } from 'semantic-ui-react';
import {
  NewOverallRecommendationStore,
  CreateOverallRecommendationDto
} from 'stores/configuration/overall-recommendations/overall-recommendations-store';
import { nameof } from 'utils/object';

interface NewOverallRecommendationViewProps extends WithTranslation {
  onClose: (isSuccess: boolean) => void;
  newOverallRecommendation?: NewOverallRecommendationStore;
}

interface NewOverallRecommendationViewState {
  userClickedSaved: boolean;
}

@connect(['newOverallRecommendation', NewOverallRecommendationStore])
class NewOverallRecommendationView extends React.Component<NewOverallRecommendationViewProps, NewOverallRecommendationViewState> {
  private get newOverallRecommendationStore() {
    return this.props.newOverallRecommendation;
  }

  constructor(props: NewOverallRecommendationViewProps) {
    super(props);
    this.newOverallRecommendationStore.createNew({
      name: '',
      description: '',
      active: true
    });
    this.state = {
      userClickedSaved: false
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: NewOverallRecommendationViewProps) {
    if (this.newOverallRecommendationStore.state.result && this.newOverallRecommendationStore.state.result.isSuccess) {
      nextProps.onClose(true);
    }
  }

  @autobind
  private onCreateNewItem() {
    this.setState({ userClickedSaved: true });
    this.newOverallRecommendationStore.submit();
  }

  @autobind
  private onCancelNewItem() {
    this.newOverallRecommendationStore.clear();
    this.props.onClose(false);
  }

  @autobind
  private handleValue(property: string, value: any) {
    this.setState({ userClickedSaved: false });
    const change = {};
    change[property] = value;
    this.newOverallRecommendationStore.change({ ...this.newOverallRecommendationStore.state.item, ...change });
  }

  public render() {
    const { t } = this.props as any;

    return (
      <Modal open closeOnEscape={true} onClose={this.onCancelNewItem} closeOnDimmerClick={false}>
        <Dimmer active={this.newOverallRecommendationStore.state.isBusy} style={{ background: 'rgba(0, 0, 0, 0.4)' }}>
          <Loader indeterminate>{t('')}</Loader>
        </Dimmer>
        <Modal.Header className="modal__header">{t('New Overall Recommendation')}</Modal.Header>
        <Modal.Content image>
          <Container>
            <Dimmer active={this.newOverallRecommendationStore.state.isBusy} inverted>
              <Loader size="large" indeterminate inverted></Loader>
            </Dimmer>
            {this.newOverallRecommendationStore.state.result && !this.newOverallRecommendationStore.state.result.isSuccess && (
              <Message
                className="error-message__style"
                icon="exclamation circle"
                error
                header={t('An error ocurred')}
                list={this.newOverallRecommendationStore.state.result.messages.map(o => o.body)}
              />
            )}
            {this.newOverallRecommendationStore.state.item && (
              <Form>
                <Form.Group widths="equal" className="overall-recommendation-form-group">
                  <Form.Input
                    error={!this.newOverallRecommendationStore.state.item.name && this.state.userClickedSaved}
                    required
                    fluid={!this.newOverallRecommendationStore.state.item.name}
                    label={t('Name')}
                    placeholder={t('Name')}
                    value={this.newOverallRecommendationStore.state.item.name}
                    onChange={(e, { value }) => this.handleValue(nameof<CreateOverallRecommendationDto>('name'), value)}
                  />

                  <Form.Input
                    fluid={!this.newOverallRecommendationStore.state.item.description}
                    label={t('Description')}
                    placeholder={t('Description')}
                    value={this.newOverallRecommendationStore.state.item.description}
                    onChange={(e, { value }) => this.handleValue(nameof<CreateOverallRecommendationDto>('description'), value)}
                  />

                  <Form.Checkbox
                    style={{ top: 25 }}
                    toggle
                    checked={this.newOverallRecommendationStore.state.item.active}
                    label={t('Active')}
                    placeholder={t('Active')}
                    onChange={(e, { checked }) => {
                      this.handleValue(nameof<CreateOverallRecommendationDto>('active'), checked);
                    }}
                  />
                </Form.Group>
              </Form>
            )}
          </Container>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.onCancelNewItem} basic>
            {t('Cancel')}
          </Button>
          <Button onClick={this.onCreateNewItem} positive>
            {t('Save')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation()(NewOverallRecommendationView);
